import { termosStep } from '../../shared/termosSections';
import { identificacaoSociedadeSection } from '../../shared/sociedadeSections';

const pedidoCopiaProcessoSociedadeConfig = {
  id: 'pedido_copia_processo_sociedade',
  nome: 'Pedido de Cópia de Processo - Sociedade',
  descricao: 'Solicitação de cópia de processo relativo à sociedade',
  icon: 'FaFileContract',
  categoria: 'sociedades',

  documentConfig: {
    required: [
      { id: 'requerimento', tipoDocumentoProcesso: 433, name: 'Requerimento', description: 'Requerimento preenchido e assinado digitalmente', required: true }
    ]
  },

  paymentConfig: {
    amount: 0
  },

  protocoloConfig: {
    modeloRequerimento: '317',
    tiposAssunto: '835',
    tipoPedido: '462',
    departamentoDestino: '89'
  },

  // Confirmado ao vivo: 317 não tem grupo de endereço, só EmailResidencial/TelefoneCelular.
  dadosRequerimentoConfig: {
    campos: [
      { field: 'email', campoNome: 'EmailResidencial' },
      { field: 'celular', campoNome: 'TelefoneCelular' }
    ]
  },

  steps: [
    {
      id: 'dados_sociedade',
      title: 'Dados da Sociedade',
      sections: [
        identificacaoSociedadeSection([
          { type: 'email', name: 'email', label: 'E-mail', required: true, placeholder: 'email@exemplo.com' },
          { type: 'phone', name: 'celular', label: 'Celular', required: true }
        ])
      ]
    },
    termosStep()
  ]
};

export default pedidoCopiaProcessoSociedadeConfig;
